import { RemoteConfigProperties } from "@madhive/mad-sdk";
import {
  DEFAULT_RECIPE_FILTERS,
  MINIMAL_RECIPE_FILTERS
} from "../../hooks/useAudienceData/recipeFilters";
import { DEFAULT_SEGMENT_FILTERS } from "../../hooks/useAudienceData/segmentFilters";
import { madSDK } from "lib/sdk";
import { fireAndForget } from "./async";

/**
 * Pre-warm mad-sdk caches for costly API calls.
 * This runs in the background and does not block app initialization.
 *
 * Cache warming can be disabled via the enable_audience_data_cache_warming feature flag.
 */
export const warmMadSDKCaches = async () => {
  // Check if cache warming is enabled via feature flag
  await madSDK.featureFlags.loaded();
  const isCacheWarmingEnabled = madSDK.featureFlags.isFlagEnabled(
    RemoteConfigProperties.ENABLE_AUDIENCE_DATA_CACHE_WARMING
  );

  if (!isCacheWarmingEnabled) {
    return;
  }

  // Warm recipe caches
  fireAndForget(madSDK.recipes.find(MINIMAL_RECIPE_FILTERS));
  fireAndForget(madSDK.recipes.find(DEFAULT_RECIPE_FILTERS));

  // Warm segments cache
  fireAndForget(madSDK.dmps.segments.find(DEFAULT_SEGMENT_FILTERS));
};
